import { pageHead } from "@app/framework/meta";
import { InvestorToolPage } from "@modules/investor-relations/pages";
import { trans } from "@mongez/localization";
import { MetaFunction } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";

export default function FinancialCalendar() {
  useLoaderData();

  return (
    <InvestorToolPage
      translationKey="financialCalendar"
      toolName="FinCalendar2"
    />
  );
}

export const meta: MetaFunction = () =>
  pageHead({
    title: trans("financialCalendar"),
    appendAppName: true,
  });
